import React, { Component } from 'react';
import { Link } from 'react-router-dom';

class ResellerLogo extends Component {
  render() {
    const reseller = localStorage.getItem("latestReseller")
    const url = this.props.url || "/"
    const logo = localStorage.getItem("logo")

    if (logo !== null) {
      return (
        <Link to={url} className="logo-link">
          <img src={`${process.env.REACT_APP_ROOT_DOMAIN}/${logo}`} className="logo" alt="logo"/>
        </Link>
      )
    }
    else if (reseller === "PCS") {
      return (
        <Link to={url} className="logo-link">
          <img src={"/pcs-logo.png"} className="logo pcs-logo" alt="Person Centred Software logo"/>
        </Link>
      )
    }
    else if (reseller === "Cool Care") {
      return (
        <Link to={url} className="logo-link">
          <img src={"/cool-care-logo.png"} className="logo cc-logo" alt="Cool Care logo"/>
        </Link>
      )
    }
    else {
      return (
        <Link to={url} className="logo-link">
          <img src={"/logo192.png"} className="logo dr-logo" alt="Digital Reception logo"/>
        </Link>
      )
    }
  }
}

export default ResellerLogo;
